import React, { PropsWithChildren } from 'react';
import ThemeWrapper from '@/components/ThemeWrapper';
import useInertiaData from '@/hooks/useInertiaData';

const AuthLayoutContent: React.FC<PropsWithChildren> = ({ children }) => {
    const { domain_academy } = useInertiaData();
    const logoSrc = domain_academy?.logo_url ?? '/static/img/conquerx_logo.png';

    return (
        <div className="flex min-h-screen flex-col md:flex-row">
            <div className="flex w-full items-center justify-center bg-white p-6 sm:p-8">
                <div className="w-full max-w-md">
                    {/* Logo container */}
                    <div className="mb-12 flex justify-center">
                        <img
                            src={logoSrc}
                            alt="Logo"
                            className="h-10"
                        />
                    </div>

                    {children}
                </div>
            </div>
        </div>
    );
};

const AuthLayout: React.FC<PropsWithChildren> = ({ children }) => (
    <ThemeWrapper>
        <AuthLayoutContent>{children}</AuthLayoutContent>
    </ThemeWrapper>
);

export default AuthLayout;
